import { parseURI } from '@cian/http-api';

import { pageChangeStarted, pageChangeFinished } from './actions';
import { setMlSearchSessionGuid } from '../mlSearchSessionGuid';
import { jq } from 'shared/json_query';
import { fetchOffers, prepareJsonQuery } from 'shared/services/fetchOffers';
import { fetchSeoUrlsForFirstTwoPages } from 'shared/services/fetchSeoUrlsForFirstTwoPages';
import { trackPaginationClick } from 'shared/tracking/pagination';
import { TThunkAction } from 'shared/types/redux';
import { cutDescriptionFromOffers } from 'shared/utils';
import { saveHistorySearch } from 'shared/utils/history_search';
import { offersDecorator } from 'shared/utils/offersDecorator';
import { trackPageView } from 'shared/utils/tracking/pageview';

export function changePage(page: number): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const state = getState();
    const {
      results: { jsonQuery },
      currentLocation,
      isFetching,
      config,
      logger,
      currentSubdomain,
    } = state;

    trackPaginationClick({
      currentPage: jsonQuery.page?.value || 1,
      nextPage: page,
    });

    if (isFetching) {
      return;
    }

    dispatch(pageChangeStarted());

    const mutatedJsonQuery = jq(jsonQuery).setPageNumber(page);
    const isAdditionalTop3Disabled = config.get('serp.isAdditionalTop3Enabled') !== 'true';

    const offersData = await fetchOffers(context, {
      jsonQuery: prepareJsonQuery({ jsonQuery: mutatedJsonQuery, location: currentLocation }),
    });

    /**
     * Сохранение текущего поиска для истории поисков
     */
    saveHistorySearch(offersData.seoData.h1, offersData.fullUrl, offersData.jsonQuery);

    const suggestions = offersData.suggestOffersSerializedList;

    offersData.offersSerialized = cutDescriptionFromOffers(offersData.offersSerialized, state.userAgent);

    if (suggestions) {
      offersData.suggestOffersSerializedList = cutDescriptionFromOffers(suggestions, state.userAgent);
    }

    // Обработка объявлений
    offersDecorator(offersData.offersSerialized, isAdditionalTop3Disabled);

    const paginationUrls = await fetchSeoUrlsForFirstTwoPages(context, {
      subdomain: currentSubdomain,
      jsonQuery: offersData.jsonQuery,
    });

    dispatch(pageChangeFinished(offersData, paginationUrls));
    dispatch(setMlSearchSessionGuid(offersData.mlSearchSessionGuid || null));

    const newState = getState();

    try {
      const url = parseURI(offersData.fullUrl);
      const path = `${url.path}${url.query}`;

      window.history.pushState({}, document.title, path);
    } catch (error) {
      logger.warning(error, {
        description: 'Проблема парсинга урла выдачи',
        degradation: 'Ссылка в строке поиска не поменялась при пагинации',
      });
    }

    trackPageView(
      {
        label: offersData.fullUrl,
        jsonQueryFromFilters: offersData.jsonQuery,
        results: newState.results,
        breadcrumbs: offersData.breadcrumbs,
        user: newState.user,
        profileSessionKey: newState.profileSessionKey,
        mlRankingGuid: newState.mlRankingGuid,
        mlRankingModelVersion: newState.mlRankingModelVersion,
        searchRequestId: newState.searchRequestId,
        location: newState.currentLocation,
        mlSearchSessionGuid: offersData.mlSearchSessionGuid || null,
      },
      config,
    );
  };
}
